export type DevAgentChatSessionRow = {
  uuid: string;
  title: string;
  sseTicket?: string | null;
};

export function mapDevAgentSessionsFromApi(list: any[]): DevAgentChatSessionRow[] {
  return list.map((session) => ({
    uuid: session.uuid,
    title: session.title || "Untitled",
    sseTicket: session.sse_ticket ?? null,
  }));
}
